import { StepperItem } from '@shared/src/lib/components/stepper/stepper-item/stepper-item.interface';

export function getMpmWorkflowSteps(): StepperItem.WorkflowHistory[] {
  return [
    {
      featureId: 0,
      workflows: [
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.FDP_SUBMISSION,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: true,
          isLastElement: false,
        },
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.REVIEWER_NOMINATION,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: false,
          isLastElement: false,
        },
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.PROGRESS_REVIEW,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: false,
          isLastElement: true,
        },
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.POSITION_PAPER_LETTER_SUBMISSION,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: false,
          isLastElement: false,
        },
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.REVIEW_BY_RESOURCE_PERSON,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: false,
          isLastElement: false,
        },
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.REVIEW_BY_CLUSTER_HEAD,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: false,
          isLastElement: false,
        },
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.ENDORSE_BY_APPROVER,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: false,
          isLastElement: false,
        },
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.APPROVE_BY_FDP_APPROVER,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: false,
          isLastElement: false,
        },
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.FDP_COMPLETED,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: false,
          isLastElement: true,
        },
      ],
    },
  ];
}

export function getNonMpmWorkflowSteps(): StepperItem.WorkflowHistory[] {
  return [
    {
      featureId: 0,
      workflows: [
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.FDP_SUBMISSION,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: true,
          isLastElement: false,
        },
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.REVIEWER_NOMINATION,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: false,
          isLastElement: false,
        },
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.PROGRESS_REVIEW,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: false,
          isLastElement: false,
        },
        {
          workflowName: StepperItem.FDP_STEPPER_OPTIONS_LABEL.FDP_COMPLETED,
          isCompleted: false,
          isHidden: false,
          isPreviousCompleted: false,
          isLastElement: true,
        },
      ],
    },
  ];
}
